/*@flow*/

const re = /^(\/i\/(.+?))\//;
function utilGetCommunityBaseUrl(): any | string {
  try {
    const [, base] = window.location.pathname.match(re);
    return base;
  } catch (_) {
    return '/';
  }
}
export default utilGetCommunityBaseUrl;
